export default __webpack_public_path__ + "static/media/whatsapp-whie.5ce4b3e2.svg";